import {
  Token,
  UserAgent,
  apiService,
  configure as configureSDK,
} from "@blacknut/javascript-sdk/dist";
import cryptoProvider, {
  BrowserCryptoService,
} from "@blacknut/javascript-sdk/dist/crypto";
import { setupDatadog } from "@blacknut/logging-datadog/dist";
import { Appender, LogLevel, logD } from "@blacknut/logging/dist";
import { GameLauncher } from "./GameLauncher";
import { StreamLauncher } from "./StreamLauncher";
import { configureI18N } from "./i18n/i18n";
import configHolder from "./utils/ConfigHolder";
import { LOGGING_TAG } from "./utils/logging";

cryptoProvider.service = new BrowserCryptoService();

interface Config {
  endpoint?: string;
  userToken?: Token;
  userAgent: UserAgent;
  logging?: {
    appenders?: Appender[];
    level?: LogLevel;
  };
  appVersion?: string;
  onTokenRenewed?: (token: Token, type: "user" | "family") => void;
  locale?: string;
}

export const configure = (config: Config) => {
  const locale: string = config.locale
    ? config.locale
    : navigator.language || navigator["userLanguage"];
  const i18n = configureI18N(locale);
  const _config = { ...config, locale };
  configureSDK(_config);
  configHolder.config = _config;
  configHolder.i18n = i18n;
  const endpoint = config.endpoint || "https://api.blacknut.com";
  let env: "prod" | "staging" | "dev" = "prod";
  if (endpoint.match("api.blacknut.com")) {
    env = "prod";
  } else if (endpoint.match("staging-api")) {
    env = "staging";
  } else if (endpoint.match("dev-api")) {
    env = "dev";
  }
  setupDatadog({ env, version: config.appVersion, service: "webrtc-sdk" });

  //https://blacknut.atlassian.net/browse/CA-2748
  apiService.onTokenRenewed().subscribe({
    next: (res) => {
      logD(LOGGING_TAG, "Token renewed");
      if (config.onTokenRenewed) {
        config.onTokenRenewed(res.token, res.type);
      }
    },
  });
};

export * from "@blacknut/playerwebrtc/dist/utils";
export * from "./components/Modals";
export * from "./model";
export * from "./utils";
declare const VERSION: string;
declare const PLAYER_WEBRTC_VERSION: string;

export const getVersion = () => {
  return `${VERSION}/${PLAYER_WEBRTC_VERSION}`;
};

export { GameLauncher, StreamLauncher };
